
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/frame","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#8d98aa"}},[_c('path',{attrs:{"d":"M9.01 21.25a.748.748 0 01-.53-.219l-5.02-5.01a.75.75 0 010-1.061.75.75 0 011.061 0l5.02 5.01a.75.75 0 01-.531 1.28z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M9.01 21.25a.75.75 0 01-.75-.75v-17a.75.75 0 01.75-.75.75.75 0 01.75.75v17a.75.75 0 01-.75.75z"}}),_c('g',{attrs:{"data-name":"Group 661","opacity":".4"}},[_c('path',{attrs:{"data-name":"Vector","d":"M20.01 9.26a.748.748 0 01-.53-.219l-5.02-5.01a.75.75 0 010-1.061.75.75 0 011.061 0l5.02 5.01a.75.75 0 01-.531 1.28z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M14.99 21.25a.75.75 0 01-.75-.75v-17a.75.75 0 01.75-.75.75.75 0 01.75.75v17a.75.75 0 01-.75.75z"}})])])])
          )
        }
      }
    